import { render, staticRenderFns } from "./SplitScreenMode.vue?vue&type=template&id=691daaf6&scoped=true&"
import script from "./SplitScreenMode.vue?vue&type=script&lang=ts&"
export * from "./SplitScreenMode.vue?vue&type=script&lang=ts&"
import style0 from "./SplitScreenMode.vue?vue&type=style&index=0&id=691daaf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691daaf6",
  null
  
)

export default component.exports